// extracted by mini-css-extract-plugin
export default {"calendar":"AppointmentCalendar_calendar__cMex1","expand":"AppointmentCalendar_expand__dsGCP","wlist":"AppointmentCalendar_wlist__5TyR+"};